import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IRaisonAnnulation } from '../models/raison-annulation.model';
import { InlineResponse } from '../models/inline-response.model';
import { RaisonAnnulation } from '../../features/parameters/referentials/referentials-annulation-demande/raison-annulation-demande.model';
import { ConsequenceAnnulation } from '../../features/parameters/referentials/referentials-annulation-demande/consequence-annulation-demande.model';
import { IConsequenceAnnulation } from '../models/consequence-annulation.model';
import { environment } from '../../../environments/environment';

const options = {
  headers: new HttpHeaders({
    'Content-Type': 'application/x-www-form-urlencoded',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class AnnulationDemandeClientService {
  private serviceUrl = environment.apiURL + '/services/';

  constructor(private http: HttpClient) {}

  // Raison annulation
  public getRaisonAnnulation(): Observable<IRaisonAnnulation> {
    return this.http.get<IRaisonAnnulation>(this.serviceUrl + 'raison');
  }

  public getRaisonAnnulationById(idRaisonAnnulation: number): Observable<IRaisonAnnulation> {
    return this.http.get<IRaisonAnnulation>(this.serviceUrl + 'raison' + `/${idRaisonAnnulation}`);
  }

  public addRaisonAnnulation(raison: string): Observable<InlineResponse> {
    let params = new HttpParams()
      .set('raison', raison)
      .set('id', (Math.floor(Math.random() * (999999999 - 1111111 + 1)) + 1111111).toString())
      .set('oper', 'add');

    return this.http.post<InlineResponse>(this.serviceUrl + 'raison', params, options);
  }

  public updateRaisonAnnulation(raisonAnnulation: RaisonAnnulation): Observable<InlineResponse> {
    let params = new HttpParams().set('raison', raisonAnnulation.raison).set('id', raisonAnnulation.id).set('oper', 'edit');

    return this.http.post<InlineResponse>(this.serviceUrl + 'raison', params, options);
  }

  // Conséquence annulation
  public getConsequenceAnnulation(): Observable<IConsequenceAnnulation> {
    return this.http.get<IConsequenceAnnulation>(this.serviceUrl + 'consequence');
  }

  public getConsequenceAnnulationById(idConsequenceAnnulation: number): Observable<IConsequenceAnnulation> {
    return this.http.get<IConsequenceAnnulation>(this.serviceUrl + 'consequence' + `/${idConsequenceAnnulation}`);
  }

  public addConsequenceAnnulation(consequence: string): Observable<InlineResponse> {
    let params = new HttpParams()
      .set('consequence', consequence)
      .set('id', (Math.floor(Math.random() * (999999999 - 1111111 + 1)) + 1111111).toString())
      .set('oper', 'add');

    return this.http.post<InlineResponse>(this.serviceUrl + 'consequence', params, options);
  }

  public updateConsequenceAnnulation(consequenceAnnulation: ConsequenceAnnulation): Observable<InlineResponse> {
    let params = new HttpParams().set('consequence', consequenceAnnulation.consequence).set('id', consequenceAnnulation.id).set('oper', 'edit');

    return this.http.post<InlineResponse>(this.serviceUrl + 'consequence', params, options);
  }
}
